import { Pipe, PipeTransform } from '@angular/core';
import {RentalPropertyTypeIntMap, RentalPropertyTypeMap} from "../../domain/enums/rental-property-type.enum";

@Pipe({
  name: 'propertyType',
  standalone: true
})
export class PropertyTypePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(!value){ return value; }
    const typeEnum = RentalPropertyTypeIntMap.get(<number>value);
    return typeEnum? RentalPropertyTypeMap.get(typeEnum) : value;
  }

}
